<template>
	<div id="booking_box" class="booking_box">
		<div class="w-100" style="min-height: 60vh; width: 100%; display: flex; flex-flow: row wrap; align-items: center;">
			<br>
			<div class="w-100">
				<h1 class="text-center booking_title" style="font-weight: 200; color: white;letter-spacing: 0.15em">БРОНИРОВАНИЕ</h1>
				<br>
				<TravelLineSearchFormComponent/>
<!--				<div style="-->
<!--					display: flex;-->
<!--					justify-content: center;-->
<!--					align-items: center;-->
<!--					width: 50%;-->
<!--					position: relative;-->
<!--					padding-top: 10vh;-->
<!--					margin: auto;-->
<!--				" v-for="(item, idx) in $store.getters.housingItems" :key="idx">-->
<!--					<div class="capsule_item_box_suite_order_btn">-->
<!--						<a href="#" data-tl-booking-open="true" :data-tl-room="item.data_tl_room">{{ item.title }}</a>-->
<!--					</div>-->
<!--				</div>-->
			</div>
			<br>
		</div>
	</div>
</template>

<script>

import TravelLineSearchFormComponent from "@/components/TravelLineSearchFormComponent.vue"

export default {

	name: "BookingComponent",
	components: {
		TravelLineSearchFormComponent,
	},

	computed: {
		ModalShow: {
			get: function () {
				return this.$store.getters.isModalShow || false
			},
			set: function (val) {
				this.$store.commit('isModalShowMut', val)
			}
		},

	},
	setup() {

	},
	mounted() {

	},

	data() {
		return {

		}
	},
	methods: {

	}
}
</script>

<style>

.booking_box {
	display: flex;
	align-items: start;
	position: relative;
	min-height: 60vh;
	width: 100%;
	flex-direction: column;
	flex-wrap: nowrap;
	background: #161616FF;
	font-weight: 200;
	margin:0px;
	padding:0px;
	/*overflow: hidden;*/
}

.booking_form_box {
	position: relative;
    display: flex;
    flex-flow: row nowrap;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: center;
    width: 80%;
	max-width: 756px;
	height: 7em;
    margin: 0 auto;
    align-items: center;
    /*overflow: hidden;*/
    /*border-radius: 10px;*/
    border: 1px solid transparent;
}

.booking_title {
	font-size: 2em;
}

.vhd__datepicker__input {
	font-size: 1.3em;
	height: 100%;
    display: flex;
    color: white;
    vertical-align: middle;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    align-content: center;

}
.vhd__datepicker__inner {
	height: 100%;
	background-color: #161616;
}
.vhd__datepicker__clear-button {
	fill: #242424;
}
.vhd__datepicker {
 top: auto;
}

.vhd__datepicker__dummy-wrapper,
.vhd__datepicker__wrapper,
.booking_form_box_input,
.vhd__datepicker__wrapper--grid {
	border-radius: 10px 0px 0px 10px;
	border: transparent;
	overflow: hidden;

}

.vhd__datepicker__wrapper--grid .vhd__square .vhd__datepicker__month-day  {
	border: 1px solid #161616
}
.booking_form_box_input {
	height: 100%;
	background-color: #242424;
	color: #A6CBD3;

}
.form_box_btn {
	height: 100% !important;
    border-radius: 0px 10px 10px 0px !important;
    background-color: #A6CBD3 !important;
    color: black !important;
	text-wrap: nowrap;
}
.vhd__datepicker__month-name {
    font-size: 12px;
    font-weight: 700;
    margin: 0;
    padding: 0 0 1.625em;
    pointer-events: none;
    text-align: center;
    line-height: 2em;
    height: 2.5em;
    padding-top: .5em;
}
.vhd__datepicker__month-name {
	color: white;
}
.vhd__datepicker__month-day {
	background-color: #1E2423;
	color: white;
}
.vhd__datepicker__month-day--selected {
	background-color: #A6CBD3;
	color: #161616;
}
.vhd__datepicker__months:before {
    content: "";
    background: transparent;
    bottom: 0;
    display: block;
    left: 50%;
    position: absolute;
    top: 0;
    width: 0px;
}

.vhd__datepicker__month-day--first-day-selected, .vhd__datepicker__month-day--last-day-selected {
	background-color: #A6CBD3;

	color: #161616;
}

.form-inline {
	height: 50px;
	display: flex;
	flex-flow: row wrap;
	flex-direction: row;
	flex-wrap: nowrap;
	align-items: center;
	justify-content: center;
}

.form-control {
	min-width: 350px;
}

.input-group, .form-control, input-group-prepend {
	font-size: 25px !important;
}

.input-group, .form-control {
	height: 100% !important;
}

/*[class*="_modal_header"] {*/
.modal-header {
	position: absolute;
	background: transparent;
	top: 0;
	width: 100%;
	z-index: 10;
	border: none !important;
	box-shadow: none;
}
.modal-dialog {
	margin: 0 !important;
	width: 100% !important;
	max-width: 100% !important;
	height: 100vh !important;

}
.modal-body {
	width: 100%;
	min-height: 100vh;
	padding: 0 !important;
}
.vhd__datepicker__dummy-wrapper--no-border.vhd__datepicker__dummy-wrapper {
	background-color: #161616;
}

@media (max-width: 575px) {
	.booking_form_box {
		position: relative;
		display: flex;
		flex-flow: row nowrap;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		width: 80%;
		height: 10em;
		margin: 0 auto;
		align-items: stretch;
		border: 1px solid transparent;
		/*overflow: hidden;*/

	}
	.booking_form_box_input {
		border-radius: 10px 10px 0px 0px !important;
	}
	#booking_form_box_action_button {
		border-radius: 0px 0px 10px 10px !important;
	}
	.vhd__datepicker__input {
		font-size: 1.3em;
	}
	.vhd__datepicker__month-name {
		top: 0;
	}
	.vhd__datepicker__month-day {
		color: white;
	}
	.vhd__datepicker__month {
		position: relative;
	}
}
</style>